import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Root = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  text-align: center;
  justify-content: center;
  min-height: inherit;
`;

export const DescriptionText = styled.div`
  max-width: 400px;
  ${typographyV2.bodySm};
  color: var(--text-soft);
`;

export const TitleText = styled.div`
  ${typographyV2.bodyBase};
  color: var(--text-default);
  padding-bottom: 4px;
`;
